import { Routes as RRDRoutes, Route } from "react-router-dom";
import * as pages from "../pages";
import ProtectedRoute from "./ProtectedRoute";

export default function Routes() {
  const publicRoutes = [{ path: "/login", component: pages.Login }];
  const protectedRoutes = [
    { path: "/", component: pages.Home },
    { path: "/account", component: pages.Account },
    {
      path: "/tours/:id/confirmation",
      component: pages.TourCheckoutConfirmation,
    },
    { path: "/tours/:id", component: pages.TourCheckout },
    { path: "/tours", component: pages.ToursList },
    { path: "/bookings", component: pages.BookingsList },
    { path: "/news/:id", component: pages.NewsArticle },
    { path: "/news", component: pages.News },
  ];

  return (
    <RRDRoutes>
      <Route path="/" element={<ProtectedRoute />}>
        {protectedRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={<route.component />}
          />
        ))}
      </Route>
      {publicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<route.component />}
        />
      ))}
      <Route path="*" element={<>page not found</>} />
    </RRDRoutes>
  );
}
